import { produce } from 'immer';

import { BROKERS_ACTION_TYPE } from '../actions';

const initialState = {};

const brokersReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case BROKERS_ACTION_TYPE.GET_BROKERS:
        return payload || initialState;

      case BROKERS_ACTION_TYPE.EDIT_BROKER:
      case BROKERS_ACTION_TYPE.CREATE_BROKER:
        draft[payload.brokerId] = payload;
        break;

      case BROKERS_ACTION_TYPE.DELETE_BROKER:
        delete draft[meta.brokerId];
        break;

      default:
        return state;
    }
  });

export default brokersReducer;
